import { useCallback } from 'react'
import { useAppRouting, type ViewState } from './ui/useAppRouting.js'

export function useAppNavigation() {
  const { view, setView } = useAppRouting()

  const goToLanding = useCallback(() => setView('landing'), [setView])
  const goToChat = useCallback(() => setView('chat'), [setView])
  const goToAdmin = useCallback(() => setView('admin'), [setView])
  const goToAbout = useCallback(() => setView('about'), [setView])
  const goToAiAgency = useCallback(() => setView('ai-agency'), [setView])
  const setCurrentView = useCallback((nextView: ViewState) => setView(nextView), [setView])

  return {
    currentView: view,
    setCurrentView,
    goToLanding,
    goToChat,
    goToAdmin,
    goToAbout,
    goToAiAgency,
  }
}
